import { ArrowUpRight } from "lucide-react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { SERVICES } from "../../data/content";
import { Reveal } from "./Reveal";

// asymmetric spans for a tetris bento feel
const SPAN = ["md:col-span-2", "", "", "md:col-span-2", "md:col-span-2", "", "", "md:col-span-2"];

export const Services = () => {
  const navigate = useNavigate();
  return (
    <section id="services" data-testid="services-section" className="surface-dark text-white py-24 lg:py-36">
      <div className="mx-auto w-[92%] max-w-[1280px]">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div>
            <Reveal>
              <span className="font-mono text-[11px] uppercase tracking-[0.25em] text-fc-cyan">Our Services</span>
            </Reveal>
            <Reveal delay={0.05}>
              <h2 className="mt-5 font-display font-semibold tracking-tighter leading-[0.95] text-4xl md:text-6xl">
                Complete HVAC solutions.
              </h2>
            </Reveal>
          </div>
          <Reveal delay={0.1}>
            <p className="text-white/60 max-w-sm md:text-right">Professional services engineered for your home or business.</p>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-4 border-l border-t border-white/10">
          {SERVICES.map((s, i) => (
            <motion.button
              key={s.n}
              data-testid={`service-card-${s.n}`}
              onClick={() => navigate("/contact")}
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.5, delay: (i % 4) * 0.06 }}
              className={`group text-left relative border-r border-b border-white/10 p-8 min-h-[240px] flex flex-col justify-between hover:bg-white/[0.04] transition-colors ${SPAN[i]}`}
            >
              <span className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-fc-cyan to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
              <div className="font-mono text-fc-cyan text-sm tracking-widest">{s.n}</div>
              <div>
                <h3 className="font-display text-2xl md:text-3xl tracking-tight">{s.title}</h3>
                <p className="mt-3 text-white/55 text-sm max-w-md">{s.desc}</p>
                <span className="mt-5 inline-flex items-center gap-1.5 text-fc-cyan text-xs font-mono uppercase tracking-widest">
                  {s.cta} <ArrowUpRight size={14} className="group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
                </span>
              </div>
            </motion.button>
          ))}
        </div>
      </div>
    </section>
  );
};
